import $ from '../_snowpack/pkg/jquery.js';
import firebase from '../_snowpack/pkg/firebase/app.js';
import { Capacitor, Plugins } from '../_snowpack/pkg/@capacitor/core.js';
import Users from './users.js';
import Bookmark from './bookmark.js';
import '../_snowpack/pkg/firebase/auth.js';
const { GoogleAuth, SignInWithApple } = Plugins;

const Auth = {
  uid: null,
  isIOS: Capacitor.platform === 'ios',
  isAndroid: Capacitor.platform === 'android',
  isLoggedIn: false,
  google: async function() {
    try {
      let auth;
      if (this.isIOS || this.isAndroid) {
        const res = await GoogleAuth.signIn();
        const credential = firebase.auth.GoogleAuthProvider.credential(res.authentication.idToken);
        auth = await firebase.auth().signInWithCredential(credential)
      } else {
        const provider = new firebase.auth.GoogleAuthProvider();
        auth = await firebase.auth().signInWithPopup(provider);
      }
      this.isLoggedIn = true;
      this.uid = auth.user.uid;
      this.close();
      return true;
    } catch(err) {
    	if (!['auth/popup-closed-by-user', 'auth/cancelled-popup-request'].includes(err.code))
      console.log(err);
      return false;
    }
  },
  apple: async function() {
    try {
      let auth;
      const provider = new firebase.auth.OAuthProvider('apple.com');

      if (this.isIOS) {
        const res = await SignInWithApple.Authorize();
        const credential = provider.credential({ idToken: res.response.identityToken });
        auth = await firebase.auth().signInWithCredential(credential);
      } else {
        auth = await firebase.auth().signInWithPopup(provider);
      }
      this.isLoggedIn = true;
      this.uid = auth.user.uid;
      this.close();
      return true;
    } catch(err) {
      if (err.code !== 'auth/popup-closed-by-user') console.log('Something went wrong during authentication.  Please try again after clearing your cache or using a different browser');
      return false;
    }
  },
  watchStateChange: function() {
    firebase.auth().onAuthStateChanged(async (user) => {
      setTimeout(() => $('.navigation').fadeIn(), 750);
      if (!user) return;

      this.isLoggedIn = true;
      this.uid = user.uid;
      if (!user.displayName) return this.setDisplayName();
      this.setLoginInfo();
    });
  },
  open: function() {
    $('.auth').fadeIn();
    if (Capacitor.platform === 'android') $('.apple.btn').remove();
  },
  close: function() {
  	if(this.isLoggedIn){
  		setTimeout(function(){ $('.bookmark').click(); }, 1000);
  	}
    $('.auth').fadeOut();
  },
  signout: async function() {
    await firebase.auth().signOut();
    location.reload();
  },
  delete: async function() {
    await firebase.auth().delete();
    location.reload();
  },
  deactivate: async function() {
    // TODO: Firebase Admin Function
  },
  setDisplayName: function() {//SET DISPLAY NAME
    const that = this;
    $('.displayName').fadeIn();
    $('.displayName').on('click', 'button', async function() {
      const name = $('.displayName-input').val();
      if (name.trim() === ''){
      	alert('Name is Required');
      	return;
      }

      try {
        await firebase.auth().currentUser.updateProfile({
          displayName: name.trim()
        });
        $('.displayName').fadeOut();
        await that.setLoginInfo();
      } catch (e) {
        alert('Something went wrong');
      }
    });
  },
  setLoginInfo: async function() {
    await Bookmark.getSaved(this.uid);
    Users.init(this.uid);
  },
  init: function() {
    firebase.initializeApp({
      apiKey: "AIzaSyAJUFvZ4mOpjyp34-5AWOt8iaXJXpa8s24",
      authDomain: "auth.hipster.io",
      databaseURL: "https://hipster-d0adb.firebaseio.com",
      projectId: "hipster-d0adb",
      storageBucket: "hipster-d0adb.appspot.com",
      messagingSenderId: "755864209706",
      appId: "1:755864209706:web:22b5bd5e04b08b9bb03653",
      measurementId: "G-XRSMBF2C3Z"
    });
  }
};

Auth.init();
Auth.watchStateChange();
export default Auth;
